import Layout from '@/views/layout/Layout'

const sysSettingRoute = {
  path: '/sys/setting',
  component: Layout,
  redirect: '/sys/setting/edit',
  name: 'sys.setting',
  meta: { title: '系统管理', icon: 'sys' },
  children: [
    {
      path: 'edit',
      name: 'sys.setting.edit',
      component: () => import('@/views/sys/setting.vue'),
      meta: { title: '系统设置', icon: 'ums-admin' }
    }
  ]
}

export default sysSettingRoute



// WEBPACK FOOTER //
// ./src/router/module/sysSettingRoute.js